import ImageCache from "../Shared/ImageCache";

const {ccclass, property} = cc._decorator;

@ccclass
export default class RemoteSprite extends cc.Component {
    @property(cc.String)
    private _url: string = ""

    @property({type: cc.String})
    set url (value) {
        this._url = value

        if (this._url) {
            ImageCache.loadImage(this._url, function (err, texture) {
                if (!err && this.node) {
                    this.getComponent(cc.Sprite).spriteFrame = new cc.SpriteFrame(texture)
                }
            }.bind(this))
        }else {
            this.getComponent(cc.Sprite).spriteFrame = null
        }
    }

    get url () {
        return this._url
    }
    
    start () {
        
    }
}
